import { AmountUtils } from '@shared/utils';
import { ColorsEnum, Text } from '@shared/widgets';

interface IProps {
  textValue: string;
  numberOfOutgoingPayments: number;
  numberOfApprovedOutgoingPayments: number;
  numberOfRejectedOutgoingPayments: number;
  amountOfApprovedOutgoingPayments: number;
  amountOfRejectedOutgoingPayments: number;
  currency: string;
}

export const RequestTransaction = (props: IProps) => {
  return (
    <div className='flex gap-6 max-[1024px]:flex-wrap'>
      <div className='bg-white dark:bg-soft-black p-6 w-full relative'>
        <div>
          <Text className="font-['Prata'] mb-1" size='3xl' color={ColorsEnum.Primary}>
            {props.numberOfOutgoingPayments}
          </Text>
          <Text color={ColorsEnum.Secondary}>Number of outgoing payment requests during {props.textValue}</Text>
        </div>
      </div>
      <div className='bg-white dark:bg-soft-black p-6 w-full relative'>
        <div className='mb-6'>
          <Text className="font-['Prata'] mb-1" size='3xl' color={ColorsEnum.Primary}>
            {props.numberOfApprovedOutgoingPayments}
          </Text>
          <Text color={ColorsEnum.Secondary}>Number of outgoing payment requests with status Submitted during {props.textValue}</Text>
        </div>
        <div>
          <Text className="font-['Prata'] mb-1" size='3xl' color={ColorsEnum.Primary}>
            {AmountUtils.transformToAmountWithCurrency(props.amountOfApprovedOutgoingPayments, props.currency)}
          </Text>
          <Text color={ColorsEnum.Secondary}>Amount of outgoing payment requests with status Submitted during {props.textValue}</Text>
        </div>
      </div>
      <div className='bg-white dark:bg-soft-black p-6 w-full relative'>
        <div className='mb-6'>
          <Text className="font-['Prata'] mb-1" size='3xl' color={ColorsEnum.Primary}>
            {props.numberOfRejectedOutgoingPayments}
          </Text>
          <Text color={ColorsEnum.Secondary}>Number of outgoing payment requests with status Cancelled during {props.textValue}</Text>
        </div>
        <div>
          <Text className="font-['Prata'] mb-1" size='3xl' color={ColorsEnum.Primary}>
            {AmountUtils.transformToAmountWithCurrency(props.amountOfRejectedOutgoingPayments, props.currency)}
          </Text>
          <Text color={ColorsEnum.Secondary}>Amount of outgoing payment requests with status Cancelled during {props.textValue}</Text>
        </div>
      </div>
    </div>
  );
};
